import React from 'react';
import {
  Col,
  CustomInput,
  FormGroup,
  Label,
  Row,
  TabContent,
  TabPane,
} from 'reactstrap';
import SearchInput from '../../../commons/SearchInput';
import { ContFilterYear, ContPaginationPage } from '../../../styled-components';
import generateYearOptions from '../../../lib/helpers/generateYearOptions';
import generateMonthOptions from '../../../lib/helpers/generateMonthOptions';
import generatePaginationOptions from '../../../lib/helpers/generatePaginationOptions';
import { useTranslation } from 'react-i18next';
import SignalsRentalsSalesTable from './SignalsRentalsSalesTable';
import TotalTrRentalsSales from './TotalTrRentalsSales';

const SignalsAdminRentalsSales = ({ data, query, total, onFilter, totals }) => {
  const [t] = useTranslation('SIGNALS');
  const { limit, offset } = query;

  return (
    <>
      <TabContent activeTab={'1'}>
        <TabPane tabId="1">
          <Row className="search-add-cont m-t-20" style={{ rowGap: '1rem' }}>
            <Col sm="6" md="6" lg="3" xl="3">
              <SearchInput
                query={{ search: query && query.signalman }}
                onFilter={({ search }) => onFilter({ signalman: search })}
                label={t('SIGNALMAN_SEARCH')}
              />
            </Col>

            <Col sm="6" md="6" lg="3" xl="3">
              <SearchInput
                query={{ search: query && query.admin }}
                onFilter={({ search }) => onFilter({ admin: search })}
                label={t('ADMIN_SEARCH')}
              />
            </Col>

            <Col sm="6" md="6" lg="3" xl="3">
              <SearchInput
                query={{ search: query && query.commercial }}
                onFilter={({ search }) => onFilter({ commercial: search })}
                label={t('COMMERCIAL_SEARCH')}
              />
            </Col>

            <Col sm="6" md="6" lg="3" xl="3">
              <SearchInput
                query={{ search: query && query.notes }}
                onFilter={({ search }) => onFilter({ notes: search })}
                label={t('NOTES_SEARCH')}
              />
            </Col>

            <Col sm="12" md="6" lg="3" className="select-wrapper">
              <ContFilterYear
                className="no-width"
                style={{ marginBottom: '0' }}
              >
                <Row>
                  <Col xs="6">
                    <Label>{t('ACCOUNTABILITY_MONTH_FILTER')}</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="selectAccountabilityMonth"
                        name="accountabilityMonth"
                        disabled={!query.year}
                        value={query && query.accountabilityMonth}
                        onChange={({
                          target: { value: accountabilityMonth },
                        }) => onFilter({ accountabilityMonth })}
                      >
                        {generateMonthOptions()}
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>
          </Row>

          <section style={{ marginTop: '1rem' }}>
            <SignalsRentalsSalesTable
              data={data}
              total={total}
              offset={offset}
              limit={limit}
              onFilter={onFilter}
              bottomRow={<TotalTrRentalsSales totals={totals} />}
            />

            <ContPaginationPage>
              <p>{t('COMMON:PAGINATION_PER_PAGE')}</p>

              <FormGroup>
                <CustomInput
                  type="select"
                  className="pagination-select"
                  id="perPage"
                  name="perPage"
                  value={limit}
                  onChange={({ target: { value: limit } }) => {
                    onFilter({ limit: limit });
                  }}
                >
                  {generatePaginationOptions()}
                </CustomInput>
              </FormGroup>
            </ContPaginationPage>
          </section>
        </TabPane>
      </TabContent>
    </>
  );
};

export default SignalsAdminRentalsSales;
